<template>
  <div></div>
</template>
<script>

import Swal from "sweetalert2";
import formatter from "@/kuaa/kuaa-formatter";
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import session from "@/kuaa/kuaa-sessions";

export default {
  components: {

  },
  data() {
    return {
    };
  },
  created (){
    if(this.$route.query.TelNo){
      this.inboundCall(this.$route.query.TelNo);
    }
  },
  methods: {
    inboundCall(phoneNumber){
      let options = {
        telno: phoneNumber,
        cellular: formatter.getPhoneMask(phoneNumber),
        perPage: 1
      }
      kuaaApi.sendServer(
        URL_CONST.GET_MEMBER_LIST,
        options,
        "post",
        response => {
          let item;
          if (response.data.data.contents.length == 1){
            item = response.data.data.contents[0];
            item['phoneNumber'] = phoneNumber;
          } else {
            item = {
              memberNo: undefined,
              memberHnm: "미확인",
              cellular: phoneNumber,
              phoneNumber : phoneNumber
            }
          }
          this.inboundCallModel(item);
        }
      )
    },

    inboundCallModel(memberInfo) {
      Swal.fire({
        title: "Inbound Call",
        html: `<br><em class="phone-number">${memberInfo.phoneNumber}</em><br>${memberInfo.memberHnm} ${memberInfo.memberNo}님 전화 입니다.`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-info",
        cancelButtonClass: "md-button md-default",
        confirmButtonText: "전화 받기",
        cancelButtonText: "취소",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          window.open('/Friendship/UpdateMember?TelNo='+memberInfo.phoneNumber, 'FriendshipUpdateMember');
        }
      });
    },
  }
};
</script>
<style lang="scss" scoped>
  body {background: none !important;}
</style>
